import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "outputFilePresent", pure: true })
export class OutputFilePresentPipe implements PipeTransform {
    public transform(files: any[], fileType: string): boolean {
        if (!!files && files.length > 0) {
            return files.map((file) => file.type).find((type) => type === fileType) !== undefined;
        } else {
            return false;
        }
    }
}
